import { Box, MenuItem, TextField } from '@mui/material'
import {
  BaseSourceSiteWorkCentre,
  useSettingsContext,
} from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { useBaseSourceSiteWorkCentre } from './EditSettings.data'

export const EditSettingsDataFilter = () => {
  const { state, dispatch } = useSettingsContext()
  const { selectedWorkCentre, selectedBaseSourceSite, projectId, scenarioId } =
    state

  const { data: baseSourceSiteData = [] } = useBaseSourceSiteWorkCentre({
    projectId,
    scenarioId,
  })

  const groupWorkcentresBySite = (
    data: BaseSourceSiteWorkCentre[]
  ): Record<string, string[]> => {
    return Object.fromEntries(
      Object.entries(
        data.reduce(
          (acc, item) => {
            ;(acc[item.baseSourceSiteCode] ||= new Set()).add(
              item.workcentreCode
            )
            return acc
          },
          {} as Record<string, Set<string>>
        )
      ).map(([key, value]) => [key, [...value]])
    )
  }

  const groupedData = groupWorkcentresBySite(baseSourceSiteData)

  const baseSourceSiteOptions = Object.keys(groupedData).map((site) => ({
    label: site,
    value: site,
  }))

  const AllOption = { label: 'All', value: 'All' }

  const workCentreOptions =
    selectedBaseSourceSite &&
    selectedBaseSourceSite !== 'All' &&
    groupedData[selectedBaseSourceSite]
      ? groupedData[selectedBaseSourceSite].map((wc) => ({
          label: wc,
          value: wc,
        }))
      : selectedBaseSourceSite === 'All'
        ? // Show all work centres when "All" is selected for base source site
          [
            ...new Set(baseSourceSiteData.map((item) => item.workcentreCode)),
          ].map((wc) => ({
            label: wc,
            value: wc,
          }))
        : []

  const allWorkcentreOptions = [AllOption, ...workCentreOptions]
  const allBaseSourceSiteOptions = [AllOption, ...baseSourceSiteOptions]

  const handleOnChange = (e: any) => {
    const { value, name } = e.target
    if (value === 'All') {
      dispatch({
        type: 'RESET_DROPDOWN_OPTIONS',
      })
    } else {
      dispatch({
        type:
          name === 'baseSourceSite'
            ? 'UPDATE_BASE_SOURCE_SITE'
            : 'UPDATE_WORKCENTRE',
        payload: e.target.value as string,
      })
    }
  }

  // Two compact selects for the page header's action slot. They were 40px
  // DropDowns with a dozen `!important` border rules and a stray bottom margin
  // that pushed the header out of line.
  const selectSx = { width: 180 }

  return (
    <Box sx={{ display: 'flex', gap: '8px' }}>
      <TextField
        select
        size="small"
        label="Base source site"
        name="baseSourceSite"
        value={selectedBaseSourceSite || 'All'}
        onChange={handleOnChange}
        sx={selectSx}
      >
        {allBaseSourceSiteOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        size="small"
        label="Work centre"
        name="workcentre"
        value={selectedWorkCentre || 'All'}
        onChange={handleOnChange}
        sx={selectSx}
      >
        {allWorkcentreOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  )
}
